import React from "react";
import { ArrowRight, ShoppingBag } from "lucide-react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";

const CTABanner = () => {
  return (
    <section className="py-24 bg-[#fffaf5]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative bg-gradient-to-r from-[#c4949c] to-[#a08560] rounded-3xl p-12 md:p-16 overflow-hidden">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-10">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white rounded-full blur-3xl" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-white rounded-full blur-3xl" />
          </div>

          <div className="relative z-10 text-center">
            <ShoppingBag className="w-12 h-12 text-[#3a2a26]/80 mx-auto mb-6" />
            
            <h2 className="text-3xl md:text-4xl font-bold text-[#3a2a26] mb-4">
              Browse the Full Med Spa Peptide Catalog
            </h2>

            <p className="text-xl text-[#3a2a26]/80 max-w-2xl mx-auto mb-8">
              Explore our curated catalog of research peptides — anti-aging, longevity, recovery, weight loss, and sexual wellness — with transparent labeling.
            </p>

            <Link to="/shop">
              <Button className="bg-white text-[#c4949c] hover:bg-[#fdf2f4] font-bold px-10 py-6 text-lg group">
                Visit Shop
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>

            <p className="text-sm text-[#3a2a26]/60 mt-6">
              Products are research chemicals for laboratory research only. Not medical advice.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
